import { Stack, Typography } from '@mui/material';
import { InlineStatus } from 'components/InlineStatus';
import {
  MEMBERSHIP_PLANS,
  MEMBERSHIP_PLANS_AMOUNTS,
  PLAN_CODE_TO_MEMBERSHIP_PLAN,
} from 'features/membership/membership.constants';
import { isRecurringMembership } from 'features/membership/membership.utils';
import { useMembershipManagement } from 'hooks/useMembershipManagement';
import { useSavedPaymentMethod } from 'hooks/useSavedPaymentMethod';
import { useTranslation } from 'react-i18next';
import { SubscriptionActions } from './SubscriptionActions';
import { SubscriptionDetails } from './SubscriptionDetails';

export const SubscriptionInformation = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    isLoading,
    isError,
    planCode,
    dateActiveUntil,
    isIosSubscription,
    hostedLink,
  } = useMembershipManagement();
  const { savedPaymentMethod } = useSavedPaymentMethod({
    useLoggedInState: true,
  });

  if (isLoading || isError || !planCode) {
    return <InlineStatus status={isLoading ? 'loading' : 'error'} />;
  }

  const isRecurringSubscription = isRecurringMembership(planCode);
  const membershipPlan = PLAN_CODE_TO_MEMBERSHIP_PLAN[planCode];
  const subscriptionPrice = MEMBERSHIP_PLANS_AMOUNTS[membershipPlan];
  const isMonthlySubscription = membershipPlan === MEMBERSHIP_PLANS.proMonthly;

  return (
    <Stack spacing={2} component="section">
      <Typography variant="h3">{t('membership.subscription.title')}</Typography>

      <SubscriptionDetails
        isIosSubscription={isIosSubscription}
        isMonthlySubscription={isMonthlySubscription}
        subscriptionPrice={subscriptionPrice}
        isRecurringSubscription={isRecurringSubscription}
        dateActiveUntil={dateActiveUntil}
        savedPaymentMethod={savedPaymentMethod}
      />

      <SubscriptionActions
        isIosSubscription={isIosSubscription}
        isRecurringSubscription={isRecurringSubscription}
        paymentType={savedPaymentMethod?.paymentType}
        hostedLink={hostedLink}
      />
    </Stack>
  );
};
